
import { defineComponent, onMounted, reactive, ref, toRefs } from 'vue'
import SimpleTable from '@/components/table/simple/SimpleTable.vue'
import Container from '@/components/form/container/Container.vue'
import { useI18n } from 'vue-i18n'
import { formatDate, formatThousands } from '@/utils'
import {
  PaymentAcceptanceStatementModel,
  PaymentAcceptanceStatementParamModel
} from '@/model/paymentSlip/paymentSlipHistoryModel'
import { getPaymentAcceptanceStatement } from '@/apis/paymentSlip/paymentSlipHistory'

export default defineComponent({
  name: 'AcceptanceDetailDialog',
  methods: { formatThousands },
  props: {
    inputData: {
      type: Object,
      required: true,
      default: null
    },
    labelWidth: {
      type: String,
      default: '680px'
    }
  },
  components: {
    SimpleTable,
    Container
  },
  setup(props) {
    const { t } = useI18n()
    const tableRef = ref()
    const detailTableStruct = [
      { prop: 'behaveNo', label: t('Acceptance.behaveNo') },
      { prop: 'behaveType', label: t('Acceptance.behaveType') },
      { prop: 'behaveDate', label: t('Acceptance.behaveDate'), formatter: (row: any) => formatDate(row.behaveDate, 'yyyyMMdd') },
      { prop: 'requestObject', label: t('Acceptance.requestObjectName') },
      { prop: 'requestBankName', label: t('Acceptance.requestObjectBankName') },
      { prop: 'responseObject', label: t('Acceptance.responseObject') },
      { prop: 'responseBankName', label: t('Acceptance.responseBankName') },
      { prop: 'banendFlag', label: t('Acceptance.banendFlagTrue') },
      { prop: 'signupMark', label: t('Acceptance.signupMark') }
    ]
    const dataMap = reactive({
      tableData: Array<PaymentAcceptanceStatementModel>(),
      columnStruct: detailTableStruct,
      listLoading: true,
      detailData: {},
      showFooterRejectAndProcess: true,
      showFooterRefuseAndSignature: true,
      async getData() {
        dataMap.listLoading = true
        const params: PaymentAcceptanceStatementParamModel = {
          paymentAcceptanceHistoryId: props.inputData.id
        }
        const acceptanceStatementData = await getPaymentAcceptanceStatement(params)
        if (acceptanceStatementData && acceptanceStatementData.data) {
          dataMap.tableData = acceptanceStatementData.data
        }
        // const params: PaymentSlipPageParamModel = {
        //   updatedAtStart: dataMap.searchFormModel.dateRange?.length > 0 ? dataMap.searchFormModel.dateRange[0] : null,
        //   updatedAtEnd: dataMap.searchFormModel.dateRange?.length > 1 ? dataMap.searchFormModel.dateRange[1] : null,
        //   pageCurrent: dataMap.page,
        //   pageSize: dataMap.limit
        // }
        // dataMap.detailData = {
        //   draftNo: '1111111111111',
        //   requestObject: 'xxx材料(常州)有限公司',
        //   companyCode: '100000',
        //   requestDate: '2025-10-28',
        //   receiveBankName: 'xxxx银行xxxx分行',
        //   banendFlag: '',
        //   splitFlag: '',
        //   requestEntrustPay: '',
        //   draftType: '',
        //   bankName: 'xxxx银行xxxx分行',
        //   issueDate: '',
        //   draftAmt: '12304.50',
        //   dueDate: '',
        //   usedAmount: ''
        // }

        // Just to simulate the time of the request
        setTimeout(() => {
          dataMap.listLoading = false
        }, 0.5 * 1000)
      },
      paymentDateFormat(paymentDate: Date): string {
        return formatDate(paymentDate, 'yyyy-MM-dd')
      }
    })
    onMounted(() => {
      dataMap.getData()
    })
    return {
      t,
      tableRef,
      ...toRefs(dataMap)
    }
  }
})
